/* eslint-disable @typescript-eslint/no-explicit-any */
import logo from './component/Assets/logo.png'
import logoMenu from './component/Assets/logoMenu.png'

// TODO: conf keycloak
interface ConfigInterface {
  name: string
  env: 'development' | 'production' | 'preview' | 'localhost'
  logo: any
  logoMenu: any
  email: string
  phone: string
  address: string
  frontEndUrl: string
  backEndUrl: string
  keycloak: {
    realm: string
    url: string
    clientId: string
  }
}

const configProd: ConfigInterface = {
  name: 'Phaco',
  env: 'production',
  logo,
  logoMenu,
  email: '',
  phone: '',
  address: '',
  frontEndUrl: 'https://phaco3d.app/',
  backEndUrl: 'https://api.phaco3d.app/graphql',
  keycloak: {
    realm: 'phaco',
    url: 'https://conta.phaco3d.app/auth/',
    clientId: 'app-front'
  }
}

const configDev: ConfigInterface = {
  ...configProd,
  name: 'Phaco - [DEV]',
  env: 'development',
  frontEndUrl: 'https://dev.phaco3d.app/',
  backEndUrl: 'https://dev.api.phaco3d.app/graphql'
}

const configLocal: ConfigInterface = {
  ...configProd,
  name: 'Phaco - [LOCAL]',
  env: 'localhost',
  frontEndUrl: 'https://dev.phaco3d.app/',
  backEndUrl: 'https://dev.api.phaco3d.app/graphql'
}

const configPreview: ConfigInterface = {
  ...configProd,
  name: 'Phaco - [PREVIEW]',
  env: 'preview',
  frontEndUrl: `${window.location.origin}/`,
  backEndUrl: 'https://dev.api.phaco3d.app/graphql'
}

const getEnv = (): ConfigInterface => {
  const { host } = window.location

  if (host === 'phaco3d.app') {
    return configProd
  }

  if (host === 'dev.phaco3d.app') {
    return configDev
  }

  if (host === 'localhost') {
    return configLocal
  }

  return configPreview
}

export const Config: ConfigInterface = getEnv()
